import { ID } from 'shared/types/id';
import { WordId } from 'shared/utils/nlp/get-ids-for-words';
import { isInsideIgnoredRange } from 'shared/utils/nlp/inside-ignored-range';

import { NLP } from '../../constants';

export type SyncMultiValueTokensOptions = {
  regex: RegExp;
  wantedTokens: string[];
  trailing: string;
  wordIds: WordId[];
  ignoredWordIds: ID[];
};

// Reconciles a property whose value can appear as several tokens at once (tags,
// reminders): tokens still wanted stay exactly where the user typed them, tokens
// no longer wanted are spliced out, and missing ones are appended.
export const syncMultiValueTokens = (
  input: string,
  {
    regex,
    wantedTokens,
    trailing,
    wordIds,
    ignoredWordIds,
  }: SyncMultiValueTokensOptions,
) => {
  let result = input;
  const placedTokens = new Set<string>();

  // Reversed so each splice leaves the earlier matches' indices intact.
  const matches = [...result.matchAll(regex)].reverse();
  matches.forEach((match) => {
    if (isInsideIgnoredRange(match, { wordIds, ignoredWordIds })) {
      return;
    }
    if (wantedTokens.includes(match[0])) {
      placedTokens.add(match[0]);
      return;
    }

    const matchIndex = match.index!;
    const prefix = result.substring(0, matchIndex);
    const suffix = result.substring(matchIndex + match[0].length);
    result = `${prefix.trimEnd()} ${suffix.trimStart()}`;
  });

  wantedTokens.forEach((token) => {
    if (placedTokens.has(token)) {
      return;
    }
    const cleanedInput = result
      .replace(new RegExp(NLP.pillSeparator, 'g'), ' ')
      .trim();
    result = cleanedInput
      ? `${cleanedInput} ${token}${trailing}`
      : `${token}${trailing}`;
  });

  return result;
};
